export default __webpack_public_path__ + "static/media/Aura-Egg__41.856cddb9.png";